import React, { useMemo } from "react";
import "./common.css";
import { useHistory, useLocation } from "react-router-dom";
interface NavItem {
  name: string;
  pathname: string;
  descriptor: string;
  icon: React.FC<React.SVGProps<SVGSVGElement>>;
}
interface NewNavLinkProps {
  item: NavItem;
  onClick?: () => void;
  fromSidebar?: boolean;
}
const NewNavLink: React.FC<NewNavLinkProps> = ({
  item,
  onClick,
  fromSidebar,
}) => {
  const location = useLocation();
  const history = useHistory();
  const isSelected = useMemo(
    () => location?.pathname === item?.pathname,
    [location, item],
  );
  const Icon = item.icon;

  const handleNavClick = () => {
    if (typeof onClick === "function") {
      onClick();
    } else history.push(item?.pathname);
  };

  return (
    <div
      className={`nd-nav-link-container ${isSelected ? "selected" : ""}`}
      onClick={handleNavClick}
      style={
        fromSidebar
          ? {
              flexDirection: "row",
              justifyContent: "flex-start",
              padding: 0,
            }
          : {}
      }
    >
      <Icon className="nav-item-icon" />
      <span className={`nd-nav-link-text ${isSelected ? "selected" : ""}`}>
        {item.name}
      </span>
      <span className="nav-item-descriptor">{item.descriptor}</span>
      {isSelected && <div className="nd-nav-link-indicator" />}
    </div>
  );
};

export default NewNavLink;
